import {Button, Divider, Typography } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import { Form, Formik } from 'formik';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import FormLayout from '../../components/layout/Form/FormLayout';
import { IDialogForm } from './type';
import { FormFields } from './helperFunctions';
import { isSubmitEnabled } from '../../lib/helperFuncs';
import FormActionButtonLayout from '../layout/Form/FormActionButtonLayout';
import { useTranslation } from 'react-i18next';
import AsyncButton from '../AsyncButton/AsyncButton';

export default function DialogForm(props: IDialogForm) {
  const { open, handleClose, title, fields, initialValues, onAccept, isLoading=false,
    validationSchema } = props;

  const { t } = useTranslation();
  return (
    <>  
      <Dialog
        fullWidth
        disablePortal
        open={open}
        onClose={handleClose} 
      >
        {title
          ? <DialogTitle id='alert-dialog-title'>
            <Typography variant='h3'>{String(title)}</Typography>
          </DialogTitle>
          : null
        }
        <Divider variant='fullWidth' />
        <DialogContent>
          <Formik
            onSubmit={() => undefined}
            initialValues={initialValues}
            validationSchema={validationSchema}
            validateOnBlur={false}>
            {formik =>
              (<>
                <Form>
                  <FormLayout>
                    {FormFields(fields, formik)}
                  </FormLayout>
                  <FormActionButtonLayout>
                    <Button variant='outlined' color='error'
                      autoFocus onClick={handleClose}> {t('Ακύρωση')} </Button>
                    <AsyncButton title={t('Αποστολή')} isLoading={isLoading}
                      onClick={() => onAccept(formik.values)}
                      disabled={isSubmitEnabled(formik?.errors, formik?.dirty)} />
                  </FormActionButtonLayout>
                </Form>     
              </>)
            } 
          </Formik>  
        </DialogContent>
      </Dialog>      
    </>
  );
}
